import React from 'react';
import { OFFICIAL, PRACTICE_VIDEOS } from '../doctoralTemplate';
import { Card, Hero, SourceCard } from './dp120Parts';

interface DoctoralDocumentsViewProps {
  onNavigate?: (view: string) => void;
}

const GROUPS: [string, string, [string, string][]][] = [
  [
    'Тема и консультанты',
    '#f1b93f',
    [
      ['Обоснование темы', 'topic'],
      ['Заявление на утверждение', 'topic'],
      ['Информационная таблица руководителя', 'topic'],
      ['Пакет зарубежного консультанта', 'topic'],
    ],
  ],
  [
    'Практики и стажировка',
    '#4ce2bf',
    [
      ['План-график педагогической практики', 'practices'],
      ['Дневник-отчёт практики', 'practices'],
      ['План научной стажировки', 'internship'],
      ['Приглашение и приказ на стажировку', 'internship'],
    ],
  ],
  [
    'Финальные и защитные материалы',
    '#9b7cff',
    [
      ['Индивидуальный план', 'plan'],
      ['Комплект предзащиты', 'defense'],
      ['Архивное дело', 'completion'],
    ],
  ],
];

export const DoctoralDocumentsView: React.FC<DoctoralDocumentsViewProps> = ({ onNavigate }) => (
  <>
    <Hero
      kicker="DOCUMENT HUB"
      title="Образцы документов и видеоинструкции"
      text="Образцы открываются в своём разделе досье. Видеоинструкции ведут на уже опубликованные материалы, без отдельной копии сервиса."
      actions={
        <button type="button" className="dp120-btn" onClick={() => onNavigate?.('guide')}>
          Объяснение раздела →
        </button>
      }
    />
    <div className="dp120-source-index">
      <article style={{ ['--c' as string]: '#42d8ff' }}>
        <small>ОБРАЗОВАТЕЛЬНАЯ ПРОГРАММА</small>
        <h4>Сведения о докторантуре</h4>
        <p>Типичный срок 3 года, 180 кредитов. Код программы берётся из профиля, а не подставляется заранее.</p>
        <div className="dp120-course-actions">
          <a className="dp120-mini" href={OFFICIAL.phd} target="_blank" rel="noopener noreferrer">
            Открыть сведения
          </a>
        </div>
      </article>
      <article style={{ ['--c' as string]: '#f1b93f' }}>
        <small>ВНУТРЕННЯЯ ИНСТРУКЦИЯ</small>
        <h4>Трудоустройство · 2025</h4>
        <p>Памятка ENU по Platonus, ЭЦП и документам. Правовая актуальность проверяется по Правилам №403.</p>
        <div className="dp120-course-actions">
          <a className="dp120-mini gold" href={OFFICIAL.employmentRules} target="_blank" rel="noopener noreferrer">
            Открыть сведения
          </a>
        </div>
      </article>
      <article style={{ ['--c' as string]: '#9b7cff' }}>
        <small>ВЫПУСКНОЕ ДЕЛО</small>
        <h4>Передача личных дел выпускников</h4>
        <p>Инструкция с перечнем из 16 документов для докторантуры.</p>
        <div className="dp120-course-actions">
          <button type="button" className="dp120-mini violet" onClick={() => onNavigate?.('completion')}>
            Открыть архивное дело
          </button>
        </div>
      </article>
    </div>
    <div style={{ height: 11 }} />
    <div className="dp120-resource-groups">
      {GROUPS.map(([title, color, rows]) => (
        <article key={title} className="dp120-resource-group" style={{ ['--c' as string]: color }}>
          <h4>{title}</h4>
          <p>Рабочий образец открывается в соответствующем разделе досье.</p>
          <div className="dp120-list">
            {rows.map(([label, view]) => (
              <div key={label} className="dp120-row">
                <span>
                  <strong>{label}</strong>
                  <small>Материал / документ по применимости</small>
                </span>
                <button type="button" className="dp120-mini gold" onClick={() => onNavigate?.(view)}>
                  Открыть
                </button>
              </div>
            ))}
          </div>
        </article>
      ))}
    </div>
    <div style={{ height: 11 }} />
    <div className="dp120-resource-groups">
      <article className="dp120-resource-group" style={{ ['--c' as string]: '#42d8ff' }}>
        <h4>Видеоинструкции</h4>
        <p>Открываются во внешнем плеере. Это те же ролики по практике, без отдельного хранилища.</p>
        <div className="dp120-list">
          {PRACTICE_VIDEOS.map(([label, href]) => (
            <div key={href} className="dp120-row">
              <span>
                <strong>{label}</strong>
                <small>Видеоинструкция</small>
              </span>
              <a className="dp120-mini" href={href} target="_blank" rel="noopener noreferrer">
                Открыть
              </a>
            </div>
          ))}
        </div>
      </article>
    </div>
    <div style={{ height: 11 }} />
    <div className="dp120-grid">
      <Card title="Официальные документы" sub="Перед использованием проверять актуальную редакцию." span="span12">
        <SourceCard
          title="Официальные источники ENU / РК"
          text="Ссылки открываются во внешнем официальном источнике."
          links={[
            ['Докторантура ENU', OFFICIAL.phd],
            ['Практика ENU', OFFICIAL.practice],
            ['Диссертационный совет ENU', OFFICIAL.defense],
            ['Правила присуждения степеней', OFFICIAL.degree],
            ['Правила отработки №403', OFFICIAL.employmentRules],
          ]}
        />
      </Card>
    </div>
  </>
);
